import type { AutoSubmitOverviewEntry } from '@billda/api';

export interface OverviewRow {
  id: string;
  name: string;
  typeLabel: 'Gang' | 'Solo';
  stateLabel: 'On' | 'Off';
  sourceLabel: string;
}

export interface ShapedOverview {
  header: string;
  rows: OverviewRow[];
  emptyMessage?: string;
  footerCaption?: string;
}

const mapRow = (entry: AutoSubmitOverviewEntry): OverviewRow => ({
  id: entry.id,
  name: entry.name,
  typeLabel: entry.type === 'gang' ? 'Gang' : 'Solo',
  stateLabel: entry.effective ? 'On' : 'Off',
  sourceLabel: entry.override != null ? 'their choice' : '—',
});

/**
 * Shape the raw overview response for the read-only settings list. Row order is
 * kept exactly as the API returns it (server already sorts overrides first,
 * then name) — no client re-sort.
 */
export function shapeOverview(
  isEnabled: boolean,
  entries: AutoSubmitOverviewEntry[]
): ShapedOverview {
  if (isEnabled) {
    const rows = entries.filter(e => e.override != null).map(mapRow);

    if (rows.length === 0) {
      return {
        header: 'Overrides',
        rows,
        emptyMessage: 'Everyone follows the organisation default.',
      };
    }

    return {
      header: 'Overrides',
      rows,
      footerCaption: 'Everyone else follows the organisation default (on).',
    };
  }

  return {
    header: 'Individual settings',
    rows: entries.map(mapRow),
  };
}
